'use client'

import { useRouter } from 'next/router'
import type { PartialWidgetContext } from '@/types/cms'
import Partials from '@/elements/Partials'
import AppContext from '@/types/context'

export interface GroupWrapperProps {
  children: Array<PartialWidgetContext>
}

const WrapperTesting = ({ item, context }: { item: GroupWrapperProps; context: AppContext }) => {
  const { query } = useRouter()
  if (query.testing !== 'true') return null

  return (
    <>
      {item.children.map((widget: PartialWidgetContext, index) => {
        return <Partials key={index} item={widget as any} context={context} />
      })}
    </>
  )
}

export default WrapperTesting
